import {
  SET_LOADING,
  GET_XOSIMAGE_STATES_SUCCESS,
  XosImageState,
  XosImageTypes,
  XOSIMAGE_RESULT_SUCCESS,
  RESET_RESULTS,
} from './XosImage.types';
import { alphabeticalSort } from 'common/helpers';

const defaultState = {
  loading: false,
  xosImagesStates: null,
  result: null,
  driversData: null,
};

export function xosImageReducer(
  state = defaultState,
  action: XosImageTypes,
): XosImageState {
  console.log(action.type);
  switch (action.type) {
    case GET_XOSIMAGE_STATES_SUCCESS: {
      return {
        ...state,
        // @ts-ignore:
        xosImagesStates: alphabeticalSort(
          action.xosImageStates.map((usState) => ({
            ...usState,
            name: usState.name.toUpperCase(),
            counties: alphabeticalSort(usState.counties, 'name'),
          })),
          'name',
        ),
        loading: false,
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }
    case XOSIMAGE_RESULT_SUCCESS: {
      return {
        ...state,
        result: action.result,
        loading: false,
      };
    }
    case RESET_RESULTS: {
      return {
        ...state,
        result: null,
      };
    }
    default:
      return state;
  }
}
